import axios from "axios";
const ENV = process.env.NODE_ENV || "development";

const api = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    "Content-type": "application/json",
    "ngrok-skip-browser-warning": ENV === "development" ? true : false,
  },
});

api.interceptors.request.use(
  function (config) {
    let token = localStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers["Client-Page-Origin"] = "@" + window.location.pathname;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default api;
